import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/use-auth';

const API = process.env.REACT_APP_BACKEND_URL;

let cache = null;
export const clearAccessCache = () => { cache = null; };

/**
 * The current user-type's allowed app modules (from the RBAC matrix). Default is
 * permissive: until loaded — or for a type with no restrictions — everything is
 * allowed, so nothing flashes hidden and existing flows are unaffected.
 */
export const useAccess = () => {
  const { token } = useAuth();
  const [data, setData] = useState(cache);

  useEffect(() => {
    if (!token) return;
    if (cache) { setData(cache); return; }
    let active = true;
    fetch(`${API}/api/access/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) { cache = d; if (active) setData(d); } })
      .catch(() => {});
    return () => { active = false; };
  }, [token]);

  const appAllowed = (key) => !key || !data || (data.app_permissions || []).includes(key);
  return { appAllowed, userType: data?.user_type, loaded: !!data };
};

export default useAccess;
